import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { FrequentlyBoughtTogether } from "@/components/pdp/FrequentlyBoughtTogether";

export interface PreBookUpsellSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  handle: string;
  qty: number;
  currentImage: string | null;
  currentTitle: string;
  currentVariantId: string;
  /** Called after the pack (and any add-on) lands in the cart. */
  onAdded: () => void;
  /** Skip the add-on and add just the selected pack. */
  onSkip: () => void;
  isLoading?: boolean;
}

/**
 * Shown when a shopper taps the sticky "Pre-book" bar. One optional add-on
 * decision, then straight into the cart. Nothing is added until the shopper
 * picks an action here.
 */
export function PreBookUpsellSheet({
  open,
  onOpenChange,
  handle,
  qty,
  currentImage,
  currentTitle,
  currentVariantId,
  onAdded,
  onSkip,
  isLoading = false,
}: PreBookUpsellSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="max-h-[88vh] overflow-y-auto rounded-t-3xl border-border px-4 pb-[calc(env(safe-area-inset-bottom)+16px)] pt-5"
      >
        <SheetHeader className="mb-4 text-left">
          <SheetTitle className="font-display text-lg font-bold text-brand-deep">
            Before you pre-book
          </SheetTitle>
          <SheetDescription className="text-[12.5px] leading-snug">
            Add this optional pairing now and save, or continue with just your pack.
          </SheetDescription>
        </SheetHeader>

        <FrequentlyBoughtTogether
          handle={handle}
          qty={qty}
          currentImage={currentImage}
          currentTitle={currentTitle}
          currentVariantId={currentVariantId}
          hideHeading
          onAdded={onAdded}
        />

        <button
          type="button"
          onClick={onSkip}
          disabled={isLoading}
          className="mt-4 h-11 w-full rounded-full border border-border text-[13px] font-semibold text-muted-foreground transition-colors hover:text-foreground disabled:opacity-60"
        >
          No thanks, just my pack
        </button>
      </SheetContent>
    </Sheet>
  );
}
